export const getTime = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  const hour = d.getHours();
  const minute = d.getMinutes();
  const seconds = d.getSeconds();
  return (
    year +
    "-" +
    (month + 1) +
    "-" +
    day +
    " " +
    hour +
    ":" +
    minute +
    ":" +
    seconds
  );
};
